import rovoIconImage from './rovo-icon.png';

export const ROVO_ICON = () => <img src={rovoIconImage} alt="Rovo" width={32} height={32} />;
